// extracted by mini-css-extract-plugin
module.exports = {"outer":"Resources_outer__R4X2r","inner":"Resources_inner__REdjd","header":"Resources_header__2C1UO","title":"Resources_title__43z0k","text":"Resources_text__C5l_B"};